import { Component, OnInit, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-asistencia-salud',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './asistencia-salud.component.html',
  styleUrl: './asistencia-salud.component.scss'
})
export class AsistenciaSaludComponent implements OnInit {

  isMobileDevice: boolean = false;

  @HostListener('window:resize') // Quitamos el ['$event']
  onResize() {
    this.checkDispositivo();
  }


  ngOnInit(): void {
    this.checkDispositivo();
  }



 checkDispositivo() {
    const ua = navigator.userAgent;
    const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    
    // Aquí definimos que si el ancho es menor a 1024px, se comporte como mobile
    const isSmallScreen = window.innerWidth < 1024;

    this.isMobileDevice = isMobileUA || isSmallScreen;
  }

  

}
